<template>
  <div id="app">
    <!--路由的出口-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
  html,body,#app{
    height: 100%;
  }

  html,body,p{
    margin: 0;
    padding: 0;
  }

  body {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue